// Lookbook Section JavaScript
class LookbookSection {
  constructor() {
    this.init();
  }

  init() {
    this.setupVideos();
    this.setupAddToCart();
    this.setupResizeHandler();
  }

  setupVideos() {
    const videos = document.querySelectorAll('.lookbook__video');
    
    if (!videos.length) return;

    // Check if device is desktop (screen width >= 750px)
    const isDesktop = window.innerWidth >= 750;

    videos.forEach(video => {
      // Ensure video is properly configured
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'metadata';
      
      // Handle video loading events
      this.setupVideoLoadingEvents(video);
      
      if (isDesktop) {
        // Desktop: Only play on hover
        this.setupDesktopVideoHover(video);
      } else {
        // Mobile: Viewport-based autoplay
        this.setupMobileVideoAutoplay(video);
      }
    });
  }

  setupVideoLoadingEvents(video) {
    // Handle video loading states
    video.addEventListener('loadstart', () => {
      video.style.opacity = '0.5';
      video.classList.remove('loaded');
    });

    video.addEventListener('loadeddata', () => {
      video.style.opacity = '1';
      video.classList.add('loaded');
    });

    video.addEventListener('canplay', () => {
      video.style.opacity = '1';
      video.classList.add('loaded');
    });

    video.addEventListener('error', (e) => {
      console.log('Video loading error:', e);
      video.style.opacity = '0';
      video.classList.remove('loaded');
    });

    // Check if video is already ready
    if (video.readyState >= 2) {
      video.style.opacity = '1';
      video.classList.add('loaded');
    }
  }

  setupDesktopVideoHover(video) {
    const tile = video.closest('.lookbook__tile');
    if (!tile) return;

    // Hover events for desktop
    tile.addEventListener('mouseenter', () => {
      if (video.paused && video.readyState >= 2) {
        video.play().catch(e => console.log('Video play failed:', e));
      }
    });

    tile.addEventListener('mouseleave', () => {
      if (!video.paused) {
        video.pause();
        video.currentTime = 0; // Reset to beginning
      }
    });
  }

  setupMobileVideoAutoplay(video) {
    // Create intersection observer for mobile
    if (!this.intersectionObserver) {
      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          
          if (entry.isIntersecting) {
            // Video is in viewport - play it
            if (video.paused && video.readyState >= 2) {
              video.play().catch(e => console.log('Video autoplay failed:', e));
            }
          } else {
            // Video is out of viewport - pause it
            if (!video.paused) {
              video.pause();
            }
          }
        });
      }, {
        threshold: 0.5, // Trigger when 50% of video is visible
        rootMargin: '0px 0px -10% 0px' // Start playing when video is 10% from bottom of viewport
      });
    }

    // Start observing
    this.intersectionObserver.observe(video);
  }


  setupResizeHandler() {
    let resizeTimeout;
    
    window.addEventListener('resize', () => {
      // Debounce resize events
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Clean up existing observers
        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
          this.intersectionObserver = null;
        }
        
        // Reinitialize video behavior on resize
        this.setupVideos();
      }, 250);
    });
  }

  setupAddToCart() {
    const addToCartForms = document.querySelectorAll('.lookbook__add-to-cart-btn');
    
    addToCartForms.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation(); // Prevent the link from being triggered
        const form = btn.closest('form');
        if (form) {
          this.addToCartFromTile(form, btn);
        }
      });
    });
  }

  async addToCartFromTile(form, btn) {
    if (btn.disabled) return;

    const formData = new FormData(form);
    const originalText = btn.textContent;
    
    // Show loading state
    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        // Success
        btn.textContent = 'Added!';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);

        // Update cart count if needed
        this.updateCartCount();
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      btn.textContent = 'Error - Try Again';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 3000);
    }
  }

  updateCartCount() {
    // Update cart count in header if it exists
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('.cart-count, .cart-counter');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });
      })
      .catch(error => console.log('Error updating cart count:', error));
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.lookbook')) {
    new LookbookSection();
  }
});

// Re-initialize on section load (for theme editor)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.lookbook')) {
    new LookbookSection();
  }
});